import { useEffect, useState } from 'react';

import DifferentPortalModal from './DifferentPortalModal';
import MicrosoftLoginButton from './MicrosoftLoginButton';
import SsoErrorModal from './SsoErrorModal';
import {
  ParsedMicrosoftError,
  parseMicrosoftError,
} from './parseMicrosoftError';
import { Scope } from './useMicrosoftConfig';

interface Props {
  scope: Scope;
  returnTo?: string;
}

export default function MicrosoftSection({ scope, returnTo }: Props) {
  const [parsed, setParsed] = useState<ParsedMicrosoftError | null>(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const result = parseMicrosoftError(params);
    if (!result) {
      return;
    }
    setParsed(result);
    setShowModal(true);

    // Clean query so a refresh doesn't re-show the modal.
    const url = new URL(window.location.href);
    url.searchParams.delete('error');
    url.searchParams.delete('email');
    url.searchParams.delete('availableScopes');
    window.history.replaceState({}, '', url.toString());
  }, []);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <MicrosoftLoginButton scope={scope} returnTo={returnTo} />
      {parsed?.code === 'NOT_SCOPE' ? (
        <DifferentPortalModal
          isOpen={showModal}
          targetPortalUrl={parsed.targetPortalUrl}
          email={parsed.email}
          onClose={closeModal}
        />
      ) : parsed ? (
        <SsoErrorModal
          isOpen={showModal}
          errorCode={parsed.code}
          email={parsed.email}
          onClose={closeModal}
        />
      ) : null}
    </>
  );
}
